export default __webpack_public_path__ + "6529516c7f8bc0d986d489ec845eee08.png";